import IconClose from '@assets/icons/close.svg?react';
import IconSearch from '@assets/icons/search.svg?react';
import { Box, IconButton, InputBase, TextField, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import customColors from '../../utils/customColors';

const FieldSearch = ({
 searchValue,
 setSearchValue,
 label,
}: {
 searchValue: string;
 setSearchValue: (value: string) => void;
 label: string;
}) => {
 const { t } = useTranslation();
 return (
  <Box
   sx={{
    pr: '4px',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${customColors.lightestGray}`,
   }}
  >
   <InputBase
    value={searchValue || ''}
    sx={{ ml: '12px', flex: 1, fontWeight: 500 }}
    placeholder={label}
    inputProps={{ 'aria-label': label }}
    fullWidth
    onChange={(e) => setSearchValue(e.target.value)}
    // slotProps={{
    //  input: {
    //   disableUnderline: true,
    //  },
    // }}
   />
   {/* <TextField
    size="small"
    value={searchValue || ''}
    label={label}
    variant="outlined"
    sx={{
     border: 0,
     '& .MuiInputBase-root': {
      backgroundColor: (theme: Theme) => theme.palette.kemek.white,
      border: 0,
     },
    }}
   /> */}

   <IconButton
    onClick={() => searchValue && setSearchValue('')}
    sx={{ width: 24, height: 24, p: '4px' }}
   >
    {searchValue ? <IconClose /> : <IconSearch />}
   </IconButton>
  </Box>
 );
};

export default FieldSearch;
